<div id="{{ identifier }}" class="input-group date">
  <input type="text" class="form-control" [attr.placeholder]="placeholder" (blur)="onTouched()" />
  <span class="input-group-addon">
    <span class="glyphicon glyphicon-calendar"></span>
  </span>
</div>
